import React from "react";
import styles from "./IndicatorButton.module.css";
import clsx from "clsx";

export type IndicatorType = "ping" | "check" | "none";
type IndicatorButtonProps = {
	indicator?: IndicatorType;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const IndicatorButton = ({
	indicator = "none",
	className,
	style,
	children,
	...props
}: Readonly<IndicatorButtonProps>) => {
	return (
		<button
			className={clsx(styles.indicatorButton, className)}
			style={style}
			{...props}
		>
			{children}
			{indicator === "ping" && <span className={styles.indicatorDot} />}
			{indicator === "check" && (
				<span className={styles.indicatorCheck} aria-label="completed">
					<svg viewBox="0 0 12 12" role="img" focusable="false">
						<polyline points="2.5 6.5 5 9 9.5 3" />
					</svg>
				</span>
			)}
		</button>
	);
};
